import useSubdomain from 'hooks/useSubdomain/useSubdomain'
import { EnumRegisterStatus } from 'interfaces'
import { useEffect } from 'react'
import globalService from 'Services/api/global.service'

const useCheckInstallLocation = (
    shouldCheck: boolean,
    onEndCheck: (isSuccess: boolean) => void,
    subdomainOverride?: string,
) => {
    const { subdomain: currentSubdomain } = useSubdomain()
    const subdomain = subdomainOverride ?? currentSubdomain

    useEffect(() => {
        if (!shouldCheck) {
            //do not check on this page, redirect to subdomain page
            onEndCheck(true)
            return
        }
        const checkRegisterFn = async () => {
            try {
                const res = await globalService.checkRegisterStatus(subdomain)

                if (
                    res.data === EnumRegisterStatus.Completed ||
                    res.data === EnumRegisterStatus.NotFound
                ) {
                    onEndCheck(true)
                    clearInterval(checkRegisterInterval)
                } else if (res.data === EnumRegisterStatus.Error) {
                    clearInterval(checkRegisterInterval)
                    onEndCheck(false)
                }
            } catch (err) {
                clearInterval(checkRegisterInterval)
                onEndCheck(false)
            }
        }
        // keep retry check every 5 seconds when return `EnumRegisterStatus` is 'in-progress'
        const checkRegisterInterval = setInterval(checkRegisterFn, 5000)

        return () => clearInterval(checkRegisterInterval)
    }, [subdomain, onEndCheck, shouldCheck])
}

export default useCheckInstallLocation
